import React from "react";

export default function Footer() {
  return (
    <div className="footer font-small bg-dark pt-2 fixed">
      <div className="footer-copyright text-center py-3 text-white">
        © 2020 Copyright:
        <a className="bg-dark text-white"> covid19-tracker</a>
      </div>
    </div>
  );
}
